import { render, staticRenderFns } from "./proposition.vue?vue&type=template&id=e3fa03d2"
import script from "./proposition.vue?vue&type=script&lang=ts"
export * from "./proposition.vue?vue&type=script&lang=ts"
import style0 from "./proposition.vue?vue&type=style&index=0&id=e3fa03d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports